/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

/* === TREVDA: SKU updater (works on Relay soft navigation) START === */
(function () {
  const DEBUG = false;
  const log = (...a) => DEBUG && console.log('[trevda-sku]', ...a);

  // Prevent stacking if the theme re-executes scripts
  if (window.__TREVDA_SKU_BOOTED__) return;
  window.__TREVDA_SKU_BOOTED__ = true;

  let stopFns = [];
  let lastPath = location.pathname + location.search;

  function cleanup() {
    stopFns.forEach(fn => { try { fn(); } catch(e) {} });
    stopFns = [];
  }

  function isProductPage() {
    return /^\/products\/[^\/]+/.test(location.pathname);
  }

  function getHandle() {
    const m = location.pathname.match(/^\/products\/([^\/]+)/);
    return m ? m[1] : '';
  }

  function findIdInputs() {
    return [...document.querySelectorAll("form[action^='/cart/add'] input[name='id']")];
  }

  function getVariantId() {
    // URL param first
    try {
      const v = new URL(location.href).searchParams.get('variant');
      if (v) return String(v);
    } catch (e) {}

    // Visible input first (sticky vs main form)
    const inputs = findIdInputs();
    const visible = inputs.find(i => i.offsetParent !== null) || inputs[0];
    return visible && visible.value ? String(visible.value) : '';
  }

  function ensureSkuSpan() {
    // If your custom span exists, use it
    let span = document.querySelector('.js-variant-sku');
    if (span) return span;

    // Otherwise normalize existing theme SKU container (prevents duplicates)
    let wrap = document.querySelector('.product__sku');
    if (!wrap) return null;

    wrap.innerHTML = "<strong>SKU:</strong> <span class='js-variant-sku'>—</span>";
    return wrap.querySelector('.js-variant-sku');
  }

  async function fetchProductJson() {
    const handle = getHandle();
    if (!handle) return null;

    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) return null;
    return res.json();
  }

  function buildVariantMap(productJson) {
    const map = Object.create(null);
    (productJson.variants || []).forEach(v => {
      map[String(v.id)] = v;
    });
    return map;
  }

  async function startWhenReady() {
    if (!isProductPage()) return;

    // Wait for product DOM to exist (Relay may swap it in after script runs)
    const waitStart = Date.now();
    const wait = setInterval(async () => {
      // bail after 10s
      if (Date.now() - waitStart > 10000) {
        clearInterval(wait);
        return;
      }

      const skuSpan = ensureSkuSpan();
      const idInputs = findIdInputs();
      if (!skuSpan || idInputs.length === 0) return;

      clearInterval(wait);

      const productJson = await fetchProductJson();
      if (!productJson) return;

      const byId = buildVariantMap(productJson);
      let lastId = null;

      const update = () => {
        const id = getVariantId();
        if (!id || id === lastId) return;
        lastId = id;

        const v = byId[id];
        skuSpan.textContent = (v && v.sku) ? v.sku : '—';
        log('updated', { id, sku: skuSpan.textContent });
      };

      // Initial update
      update();

      // Watch id input changes
      const mo = new MutationObserver(update);
      idInputs.forEach(input => mo.observe(input, { attributes: true, attributeFilter: ['value'] }));
      stopFns.push(() => mo.disconnect());

      // Fallback poll (covers silent value changes)
      const poll = setInterval(update, 150);
      stopFns.push(() => clearInterval(poll));

      // Clicks on pills/buttons
      const clickHandler = () => setTimeout(update, 60);
      document.addEventListener('click', clickHandler, true);
      stopFns.push(() => document.removeEventListener('click', clickHandler, true));

      // Theme events (Design mode / section reloads)
      const sectionHandler = () => setTimeout(update, 0);
      document.addEventListener('shopify:section:load', sectionHandler);
      stopFns.push(() => document.removeEventListener('shopify:section:load', sectionHandler));
    }, 100);

    stopFns.push(() => clearInterval(wait));
  }

  function bootIfNavigated() {
    const now = location.pathname + location.search;
    if (now === lastPath) return;
    lastPath = now;

    cleanup();
    startWhenReady();
  }

  // Initial
  startWhenReady();

  // Catch soft nav (history)
  const _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(this, arguments);
    setTimeout(bootIfNavigated, 0);
  };

  const _replaceState = history.replaceState;
  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    setTimeout(bootIfNavigated, 0);
  };

  window.addEventListener('popstate', () => setTimeout(bootIfNavigated, 0));

  // Also catch click-driven navigation where history is updated later
  document.addEventListener('click', () => setTimeout(bootIfNavigated, 300), true);
})();
/* === TREVDA: SKU updater (works on Relay soft navigation) END === */





  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
